import { render, staticRenderFns } from "./duoLandingPageMobile.vue?vue&type=template&id=53443056&scoped=true&"
import script from "./duoLandingPageMobile.vue?vue&type=script&lang=js&"
export * from "./duoLandingPageMobile.vue?vue&type=script&lang=js&"
import style0 from "./duoLandingPageMobile.vue?vue&type=style&index=0&id=53443056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53443056",
  null
  
)

export default component.exports